import { RpcError } from "grpc-web";
import { AddMemberToEnterpriseRequest, AddMemberToEnterpriseResponse, DeleteEnterpriseMemberRequest, DeleteEnterpriseMemberResponse, EnterpriseDetails, GetEnterpriseAllUsersRequest, GetEnterpriseAllUsersResponse, GetEnterprisesForUserRequest, GetEnterprisesForUserResponse, GetInvitationPendingUsersForEnterpriseRequest, GetInvitationPendingUsersForEnterpriseResponse, GetPendingEnterpriseInvitesRequest, GetPendingEnterpriseInvitesResponse, UpdateMemberOfEnterpriseRequest, UpdateMemberOfEnterpriseResponse } from "../proto/api_pb";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { backOff } from "exponential-backoff";
import { getRoleNumber } from "../pages/Projects/types";


export const getEnterpriseAllUsers = async (
    token: string,
    enterpriseId: string
): Promise<RpcError | GetEnterpriseAllUsersResponse | undefined> => {
    try {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new GetEnterpriseAllUsersRequest();
        request.setEnterpriseId(enterpriseId)

        const metadata = {
            Authorization: `${token}`,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<RpcError | GetEnterpriseAllUsersResponse>((resolve, reject) => {
                    ommuseClient.getEnterpriseAllUsers(
                        request,
                        metadata,
                        function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                resolve(response);
                            }
                        }
                    );
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    } catch (e) {
        console.log(e);
    }
};


export const addMemberToEnterprise = async (
    token: string,
    email: string,
    role: string,
    enterpriseId: string,
    enterpriseName: string,
    inviterName: string
): Promise<RpcError | AddMemberToEnterpriseResponse | undefined> => {
    try {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new AddMemberToEnterpriseRequest();
        request.setEmail(email)
        const details = new EnterpriseDetails();
        details.setRole(getRoleNumber(role)?.toString() ?? '')
        details.setEnterpriseId(enterpriseId)
        details.setEnterpriseName(enterpriseName)
        const timestamp = Date.now();
        details.setDateAdded(timestamp)
        details.setLastActive(timestamp)
        request.setEnterpriseDetails(details)
        request.setInviterName(inviterName)
        const metadata = {
            Authorization: `${token}`,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<RpcError | AddMemberToEnterpriseResponse>((resolve, reject) => {
                    ommuseClient.addMemberToEnterprise(
                        request,
                        metadata,
                        function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                resolve(response);
                            }
                        }
                    );
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    } catch (e) {
        console.log(e);
    }
};


export const updateEnterpriseMember = async (
    token: string,
    email: string,
    enterpriseId: string,
    role: string
): Promise<RpcError | UpdateMemberOfEnterpriseResponse | undefined> => {
    try {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new UpdateMemberOfEnterpriseRequest();
        request.setEmail(email)
        request.setEnterpriseId(enterpriseId)
        request.setNewRole(getRoleNumber(role)?.toString() ?? '')
        const metadata = {
            Authorization: `${token}`,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<RpcError | UpdateMemberOfEnterpriseResponse>((resolve, reject) => {
                    ommuseClient.updateMemberOfEnterprise(
                        request,
                        metadata,
                        function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                resolve(response);
                            }
                        }
                    );
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    } catch (e) {
        console.log(e);
    }
};

export const deleteEnterpriseMember = async (
    token: string,
    email: string,
    enterpriseId: string
): Promise<RpcError | DeleteEnterpriseMemberResponse | undefined> => {
    try {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new DeleteEnterpriseMemberRequest();
        request.setEmail(email)
        request.setEnterpriseId(enterpriseId)
        const metadata = {
            Authorization: `${token}`,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<RpcError | DeleteEnterpriseMemberResponse>((resolve, reject) => {
                    ommuseClient.deleteEnterpriseMember(
                        request,
                        metadata,
                        function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                resolve(response);
                            }
                        }
                    );
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    } catch (e) {
        console.log(e);
    }
};

export const getAllUserEnterprises = async (
    token: string,
    enterpriseIds: string[]
): Promise<RpcError | GetEnterprisesForUserResponse | undefined> => {
    try {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new GetEnterprisesForUserRequest();
        request.setEnterpriseIdsList(enterpriseIds)
        const metadata = {
            Authorization: `${token}`,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<RpcError | GetEnterprisesForUserResponse>((resolve, reject) => {
                    ommuseClient.getEnterprisesForUser(
                        request,
                        metadata,
                        function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                resolve(response);
                            }
                        }
                    );
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    } catch (e) {
        console.log(e);
    }
};




export const getPendingInvitation = async (
    token: string,
    email: string
): Promise<RpcError | GetPendingEnterpriseInvitesResponse | undefined> => {
    try {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new GetPendingEnterpriseInvitesRequest();
        request.setEmail(email)
        const metadata = {
            Authorization: `${token}`,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<RpcError | GetPendingEnterpriseInvitesResponse>((resolve, reject) => {
                    ommuseClient.getPendingEnterpriseInvites(
                        request,
                        metadata,
                        function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                resolve(response);
                            }
                        }
                    );
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    } catch (e) {
        console.log(e);
    }
};


export const getEnterprisePendingInvitation = async (
    token: string,
    enterpriseId: string
): Promise<RpcError | GetInvitationPendingUsersForEnterpriseResponse | undefined> => {
    try {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new GetInvitationPendingUsersForEnterpriseRequest();
        request.setEnterpriseId(enterpriseId)
        const metadata = {
            Authorization: `${token}`,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<RpcError | GetInvitationPendingUsersForEnterpriseResponse>((resolve, reject) => {
                    ommuseClient.getInvitationPendingUsersForEnterprise(
                        request,
                        metadata,
                        function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                resolve(response);
                            }
                        }
                    );
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    } catch (e) {
        console.log(e);
    }
};

